import React from 'react';

interface SuccessIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const SuccessIcon: React.FC<SuccessIconProps> = ({
  width = 46,
  height = 46,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1666 23.0007C42.1666 33.586 33.5853 42.1673 22.9999 42.1673C12.4145 42.1673 3.83325 33.586 3.83325 23.0007C3.83325 12.4152 12.4145 3.83398 22.9999 3.83398C33.5853 3.83398 42.1666 12.4152 42.1666 23.0007ZM30.7247 17.1925C31.2861 17.7539 31.2861 18.6641 30.7247 19.2254L21.1413 28.8087C20.5799 29.3701 19.6699 29.3701 19.1085 28.8087L15.2751 24.9754C14.7137 24.414 14.7137 23.504 15.2751 22.9426C15.8365 22.3812 16.7467 22.3812 17.3081 22.9426L20.1249 25.7593L24.4083 21.4759L28.6918 17.1925C29.2532 16.6311 30.1633 16.6311 30.7247 17.1925Z"
        fill="#3EAA7E"
      />
    </svg>
  );
};

export default SuccessIcon;
